import { Button } from '../../../styles/GlobalComponents';
import { Link, useHistory } from 'react-router-dom';
import { Box, Flexed } from '../../../styles/GlobalComponents';
import { Icon, IconApproveNFTFail } from '../../../styles/Icons';
import { P2 } from '../../../styles/FontStyles';
import { DASHBOARD } from '../../../routes/routes';
import { useDispatch } from 'react-redux';
import { setPurchaseCardStep } from '../Marketplace.actions';
import { PurchaseSteps } from '../Maeketplace.types';

export const Failed = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  return (
    <>
      <Box gray>
        <Flexed column center>
          <Flexed>
            <Icon mb='20'>
              <IconApproveNFTFail />
            </Icon>
          </Flexed>
        </Flexed>

        <P2 bold center mb='20'>
          Unfortunately, your payment could not be processed. Please try again .
        </P2>

        <Flexed column center>
          <Button
            w='200px'
            negative
            onClick={() => {
              history.push(DASHBOARD);
            }}>
            Back to Dashboard
          </Button>
        </Flexed>
      </Box>
    </>
  );
};
